module.exports = __webpack_public_path__ + "public/SiteIcons/listLocatiionPin.svg?8a9036db";